import { decodeColor } from 'betterplace-utils'
import { useTranslations } from 'next-intl'
import type { CSSProperties } from 'react'
import TrustedHtml from '@/components/TrustedHtml'

export default function ScreenName({
  authorName,
  style,
  className,
  screenNameFont,
  screenNameFontColor,
  screenNameFontWeight,
  screenNameFontSize,
}: {
  authorName?: string | null
  style?: CSSProperties
  className?: string
  screenNameFont?: string
  screenNameFontColor?: string
  screenNameFontWeight?: number
  screenNameFontSize?: number
}) {
  const t = useTranslations('nextjs.streambot.screen_name')
  return (
    <TrustedHtml
      style={
        {
          'whiteSpace': 'nowrap',
          'overflow': 'hidden',
          'textOverflow': 'ellipsis',
          'minWidth': 0,
          '--streambot-screen-name-font': screenNameFont,
          '--streambot-screen-name-font-color': decodeColor(screenNameFontColor),
          '--streambot-screen-name-font-weight': screenNameFontWeight,
          '--streambot-screen-name-font-size': screenNameFontSize && `${screenNameFontSize}px`,
          ...style,
        } as CSSProperties
      }
      className={`screenName ${className}`}
      value={authorName || t('anonymous_user')}
    />
  )
}
